// Le dimensioni del raster di un JPEG lette dall'intestazione (segmento SOF), SENZA applicare l'orientamento EXIF: è il modo in cui le legge il
// decoder di Dim.Tools quando controlla la foto nativa del bundle. Un decoder del browser potrebbe girarla e dichiarare larghezza e altezza scambiate.

/** Larghezza e altezza in pixel, oppure null se il file non è un JPEG leggibile. */
export function jpegSize(bytes: Uint8Array): { widthPx: number; heightPx: number } | null {
  if (bytes.length < 4 || bytes[0] !== 0xff || bytes[1] !== 0xd8) return null;
  let i = 2;
  while (i + 9 < bytes.length) {
    if (bytes[i] !== 0xff) return null;
    const marker = bytes[i + 1]!;
    if (marker === 0xff) {
      i += 1; // riempimento fra segmenti
      continue;
    }
    const length = (bytes[i + 2]! << 8) | bytes[i + 3]!;
    // SOF0…SOF15 tranne DHT (C4), JPG (C8) e DAC (CC): lì ci sono altezza e larghezza.
    if (marker >= 0xc0 && marker <= 0xcf && marker !== 0xc4 && marker !== 0xc8 && marker !== 0xcc) {
      return { heightPx: (bytes[i + 5]! << 8) | bytes[i + 6]!, widthPx: (bytes[i + 7]! << 8) | bytes[i + 8]! };
    }
    i += 2 + length;
  }
  return null;
}
